export enum ZoomLevel {
	ONE_MINUTE = 1,
	FIVE_MINUTES = 5,
	FIFTEEN_MINUTES = 15,
	THIRTY_MINUTES = 30,
	SIXTY_MINUTES = 60
}
